function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { _ as e } from "./5301ccd2.mjs";
import { stringifyVariables as r } from "@urql/core";
var a = {
  __typename: "PageInfo",
  endCursor: null,
  startCursor: null,
  hasNextPage: !1,
  hasPreviousPage: !1
};

function ensureKey(e) {
  return "string" == typeof e ? e : null;
}

function concatEdges(e, r, a) {
  var n = new Set();

  for (var t = 0, o = r.length; t < o; t++) {
    var s = e.resolve(r[t], "node");

    if ("string" == typeof s) {
      n.add(s);
    }
  }

  var i = r.slice();

  for (var f = 0, u = a.length; f < u; f++) {
    var v = a[f];
    var l = e.resolve(v, "node");

    if ("string" == typeof l && !n.has(l)) {
      n.add(l);
      i.push(v);
    }
  }

  return i;
}

function concatNodes(e, r) {
  var a = new Set();

  for (var n = 0, t = e.length; n < t; n++) {
    var o = e[n];

    if ("string" == typeof o) {
      a.add(o);
    }
  }

  var s = e.slice();

  for (var i = 0, f = r.length; i < f; i++) {
    var u = r[i];

    if ("string" == typeof u && !a.has(u)) {
      a.add(u);
      s.push(u);
    }
  }

  return s;
}

function compareArgs(e, a) {
  for (var n in a) {
    if ("first" === n || "last" === n || "after" === n || "before" === n) {
      continue;
    } else if (!(n in e)) {
      return !1;
    }

    var t = e[n];
    var o = a[n];

    if (_typeof(t) != _typeof(o) || "object" != _typeof(t) ? t !== o : r(t) !== r(o)) {
      return !1;
    }
  }

  for (var s in e) {
    if ("first" === s || "last" === s || "after" === s || "before" === s) {
      continue;
    }

    if (!(s in a)) {
      return !1;
    }
  }

  return !0;
}

function getPage(e, r, n) {
  var t = ensureKey(e.resolve(r, n));

  if (!t) {
    return null;
  }

  var o = e.resolve(t, "__typename");
  var s = e.resolve(t, "edges") || [];
  var i = e.resolve(t, "nodes") || [];

  if ("string" != typeof o) {
    return null;
  }

  var f = {
    __typename: o,
    edges: s,
    nodes: i,
    pageInfo: a
  };
  var u = e.resolve(t, "pageInfo");

  if ("string" == typeof u) {
    var v = ensureKey(e.resolve(u, "__typename"));
    var l = ensureKey(e.resolve(u, "endCursor"));
    var g = ensureKey(e.resolve(u, "startCursor"));
    var c = e.resolve(u, "hasNextPage");
    var d = e.resolve(u, "hasPreviousPage");
    var p = f.pageInfo = {
      __typename: "string" == typeof v ? v : "PageInfo",
      hasNextPage: "boolean" == typeof c ? c : !!l,
      hasPreviousPage: "boolean" == typeof d ? d : !!g,
      endCursor: l,
      startCursor: g
    };

    if (null === p.endCursor) {
      var y = s[s.length - 1];

      if (y) {
        var m = e.resolve(y, "cursor");
        p.endCursor = ensureKey(m);
      }
    }

    if (null === p.startCursor) {
      var h = s[0];

      if (h) {
        var P = e.resolve(h, "cursor");
        p.startCursor = ensureKey(P);
      }
    }
  }

  return f;
}

function relayPagination(r) {
  if (void 0 === r) {
    r = {};
  }

  var n = r.mergeMode || "inwards";
  return function (r, t, o, s) {
    var i = s.parentKey;
    var f = s.fieldName;
    var u = o.inspectFields(i).filter(function (e) {
      return e.fieldName === f;
    });
    var v = u.length;

    if (0 === v) {
      return;
    }

    var l = null;
    var g = [];
    var c = [];
    var d = [];
    var p = [];
    var y = e({}, a);

    for (var m = 0; m < v; m++) {
      var h = u[m];
      var P = h.fieldKey;
      var _ = h.arguments;

      if (null === _ || !compareArgs(t, _)) {
        continue;
      }

      var N = getPage(o, i, P);

      if (null === N) {
        continue;
      }

      if (0 === N.nodes.length && 0 === N.edges.length && l) {
        continue;
      }

      if ("inwards" === n && "number" == typeof _.last && "number" == typeof _.first) {
        var C = N.edges.slice(0, _.first + 1);
        var I = N.edges.slice(-_.last);
        var K = N.nodes.slice(0, _.first + 1);
        var b = N.nodes.slice(-_.last);
        g = concatEdges(o, g, C);
        c = concatEdges(o, I, c);
        d = concatNodes(d, K);
        p = concatNodes(b, p);
        y = N.pageInfo;
      } else if (_.after) {
        g = concatEdges(o, g, N.edges);
        d = concatNodes(d, N.nodes);
        y.endCursor = N.pageInfo.endCursor;
        y.hasNextPage = N.pageInfo.hasNextPage;
      } else if (_.before) {
        c = concatEdges(o, N.edges, c);
        p = concatNodes(N.nodes, p);
        y.startCursor = N.pageInfo.startCursor;
        y.hasPreviousPage = N.pageInfo.hasPreviousPage;
      } else if ("number" == typeof _.last) {
        c = concatEdges(o, N.edges, c);
        p = concatNodes(N.nodes, p);
        y = N.pageInfo;
      } else {
        g = concatEdges(o, g, N.edges);
        d = concatNodes(d, N.nodes);
        y = N.pageInfo;
      }

      if (N.pageInfo.__typename !== y.__typename) {
        y.__typename = N.pageInfo.__typename;
      }

      if (l !== N.__typename) {
        l = N.__typename;
      }
    }

    if ("string" != typeof l) {
      return;
    }

    if (!!!ensureKey(o.resolve(i, f, t))) {
      if (!s.store.schema) {
        return;
      } else {
        s.partial = !0;
      }
    }

    return {
      __typename: l,
      edges: "inwards" === n ? concatEdges(o, g, c) : concatEdges(o, c, g),
      nodes: "inwards" === n ? concatNodes(d, p) : concatNodes(p, d),
      pageInfo: {
        __typename: y.__typename,
        endCursor: y.endCursor,
        startCursor: y.startCursor,
        hasNextPage: y.hasNextPage,
        hasPreviousPage: y.hasPreviousPage
      }
    };
  };
}

function simplePagination(e) {
  if (void 0 === e) {
    e = {};
  }

  var a = e.offsetArgument;

  if (void 0 === a) {
    a = "skip";
  }

  var n = e.limitArgument;

  if (void 0 === n) {
    n = "limit";
  }

  var t = e.mergeMode;

  if (void 0 === t) {
    t = "after";
  }

  function compareArgs(e, t) {
    for (var o in t) {
      if (o === a || o === n) {
        continue;
      } else if (!(o in e)) {
        return !1;
      }

      var s = e[o];
      var i = t[o];

      if (_typeof(s) != _typeof(i) || "object" != _typeof(s) ? s !== i : r(s) !== r(i)) {
        return !1;
      }
    }

    for (var f in e) {
      if (f === a || f === n) {
        continue;
      }

      if (!(f in t)) {
        return !1;
      }
    }

    return !0;
  }

  return function (e, r, n, o) {
    var s = o.parentKey;
    var i = o.fieldName;
    var f = n.inspectFields(s).filter(function (e) {
      return e.fieldName === i;
    });
    var u = f.length;

    if (0 === u) {
      return;
    }

    var v = new Set();
    var l = [];
    var g = null;

    for (var c = 0; c < u; c++) {
      var d = f[c];
      var p = d.fieldKey;
      var y = d.arguments;

      if (null === y || !compareArgs(r, y)) {
        continue;
      }

      var m = n.resolve(s, p);
      var h = y[a];

      if (null === m || 0 === m.length || "number" != typeof h) {
        continue;
      }

      var P = [];

      for (var _ = 0; _ < m.length; _++) {
        var N = m[_];

        if (v.has(N)) {
          continue;
        }

        P.push(N);
        v.add(N);
      }

      if ((!g || h > g) == ("after" === t)) {
        l = l.concat(P);
      } else {
        l = P.concat(l);
      }

      g = h;
    }

    if (n.resolve(s, i, r)) {
      return l;
    } else if (!o.store.schema) {
      return;
    } else {
      o.partial = !0;
      return l;
    }
  };
}

export { relayPagination, simplePagination };